import { css } from '@emotion/core';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
import { variables, insetBlock, media, rgba, tokens, globalTokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
var colour = variables.colour,
  font = variables.font,
  global = variables.global;
var backgroundColour = '#f5f6f7';
var alertBackgroundColour = '#ffefaf';
export var mobileAlertContainer = {
  name: "1bgztbp",
  styles: "display:flex;align-items:center;white-space:nowrap;border:0;outline:none;"
};
export var mobileAlertDivider = /*#__PURE__*/css("border-right:1px solid ", colour.neutral300, ";margin:0;width:0;height:22px;");
export var location = /*#__PURE__*/css("margin:0 15px;", media('>=tablet'), "{margin:0;}");
export var searchFilter = {
  name: "1xaekgw",
  styles: "margin-top:20px;"
};

// FIXME: styles wrapped components
export var topContent = /*#__PURE__*/css(insetBlock, " .allhomes-search-filter{display:inline-block;vertical-align:top;margin:7px 0 0 20px;}");
export var summaryContainer = /*#__PURE__*/css("margin-top:10px;", media('>=tablet', '<desktop'), "{margin-left:24px;margin-right:16px;}", media('>=tablet'), "{margin-top:22px;display:flex;}");
export var summary = /*#__PURE__*/css("display:inline-block;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colors.neutral.heavy.default, ";margin-left:16px;", media('>=tablet'), "{font-size:", font.baseFontSize, ";margin-left:0;flex-grow:1;}");
export var summaryStat = /*#__PURE__*/css("font-weight:", font.headingFontWeight, ";");
export var controls = /*#__PURE__*/css("display:flex;flex-wrap:nowrap;flex-direction:row;justify-content:flex-end;align-items:center;", media('>=tablet'), "{display:inline-block;flex-shrink:0;}");
export var sortControls = {
  name: "1qumsxp",
  styles: "width:100%;padding:0 15px;margin-top:9px;margin-bottom:5px;display:flex;"
};
export var sortSpacer = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var button = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";color:", colors.neutral.heavy.default, ";border:0;padding:0;margin-left:14px;background-color:transparent;cursor:pointer;&:focus{outline:none;}");
export var featuredProperty = /*#__PURE__*/css("width:100%;position:relative;margin:5px 0 0;", media('>=tablet'), "{margin-top:24px;}");
var _ref = {
  name: "flpniz",
  styles: "margin-bottom:60px;"
};
export var marginContainer = _ref2 => {
  var showDots = _ref2.showDots;
  return /*#__PURE__*/css("width:100%;margin:0;display:flex;justify-content:center;", showDots && _ref, " ", media('>=tablet'), "{margin-bottom:60px;}");
};
export var spinner = /*#__PURE__*/css("position:absolute;width:100%;background-color:", rgba(globalTokens.colors.white, 0.9), ";z-index:", global.layerFloating, ";padding-top:100px;height:140%;");
export var overlay = /*#__PURE__*/css("position:absolute;width:100%;height:100%;background-color:", rgba(globalTokens.colors.white, 0.9), ";z-index:", global.layerFloating, ";padding-top:100px;");
export var redirectMessageBox = /*#__PURE__*/css("background-color:", alertBackgroundColour, ";color:", colour.allhomesNavy600, ";display:flex;margin:16px 0;border-radius:3px;", media('>=tablet'), "{height:48px;}");
export var redirectMessageIcon = /*#__PURE__*/css("padding:0 12px 12px;align-self:center;", media('>=tablet'), "{padding:12px;}");
export var redirectMessageText = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";line-height:", font.smallLineHeight, ";padding-top:10px;padding-bottom:14px;", media('>=tablet'), "{font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";}");
export var redirectMessageTextPAName = {
  name: "in3yi3",
  styles: "font-weight:bold;"
};
export var itemsContainer = /*#__PURE__*/css("position:relative;background-color:", backgroundColour, ";");
export var filters = /*#__PURE__*/css(media('>=tablet', '<desktop'), "{margin-left:24px;margin-right:16px;}");
export var items = /*#__PURE__*/css(media('>=tablet'), "{margin-top:0;}");
export var ariaDialog = {
  name: "lzogf0",
  styles: "display:block;text-align:left;position:fixed;top:0;left:0;width:100%;height:100%;cursor:default;"
};
export var ariaUnderlay = /*#__PURE__*/css("position:fixed;top:0;left:0;width:100%;height:100%;z-index:", global.layerModal, ";overflow-x:hidden;overflow-y:auto;text-align:center;background:", rgba(globalTokens.colors.black, 0.5), ";cursor:pointer;");
export var breadcrumbs = /*#__PURE__*/css("margin:10px 0 16px 15px;", media('>=tablet'), "{margin-left:24px;}", media('>=desktop'), "{margin:20px 0 18px;}li:not(:last-of-type){", media('>=tablet'), "{font-weight:", font.headingFontWeight, ";color:", colour.neutral700, ";}}");
export var disclaimerLine1 = /*#__PURE__*/css("::after{content:' ';white-space:pre;}", media('>=tablet'), "{display:block;::after{content:'';}}");
export var disclaimer = /*#__PURE__*/css("margin:4px 16px;", designSystem.typography.bodySmall, " color:", colour.neutral600, ";", media('>=tablet'), "{margin:4px 24px;}", media('>=desktop'), "{margin:4px 0;}");
export var disclaimerMobileContainer = /*#__PURE__*/css(media('>=tablet'), "{display:none;}");
export var disclaimerNonMobileContainer = /*#__PURE__*/css("display:none;", media('>=tablet'), "{display:initial;}");

// This piece of text is in Body Small, but since Body Small doesn't support
// links, it is given the Body buttonLink style.
export var disclaimerButton = designSystem.typography.bodyButtonLink;